import * as yup from "yup";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";

export const onSubmitBuscarRecibo = async (submittedData, setRecibo, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().post("/obtener_recibo", submittedData);
  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    if (data === "El recibo se encuentra vencido") {
      toast.error(`El recibo para el pago del acta ${submittedData.numero_acta} ha vencido`, toastOptions);
    } else {
      setRecibo(data);
    }
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setIsLoading(false);
};

export const numeroActaSchema = yup.object({
  numero_acta: yup
    .string()
    .required("Numero de acta requerido")
    .matches(/^(DTP|DTM)-(?!0+$)[0-9]+$/i, { message: "Formato incorrecto", excludeEmptyString: true }),
});
